export enum PaymentPeriod {
    TwoYears = "TwoYears",
    FiveYears = "FiveYears",
    UpToAgeSixtyFive = "UpToAgeSixtyFive",
    UpToAgeSeventy = "UpToAgeSeventy",
    Unknown = "Unknown"
}

export default PaymentPeriod;
